module.exports = __webpack_public_path__ + "img/slice_internal_rep.2d12e3a0.png";